import { Route, Routes } from 'react-router-dom'
import { AppLayout, ProtectedRoutesLayout } from '@forwardflow/layouts'
import { CampaignRoutes } from '@forwardflow/features/campaign'
// import { lazy } from 'react'

import ProtectRoutes from './ProtectedRoutes/ProtectedRoutes'
import SettingsLayout from '@forwardflow/layouts/SettingsLayout'
import Signup from '../pages/SignUp'
import Signin from '../pages/SignIn'
import ConnectAssistant from '../pages/ConnectAssistant'
import ForgotPassword from '../pages/ForgotPassword'
import SetNewPassword from '../pages/SetNewPassword'
import Dashboard from '../pages/Dashboard'

import OnboardingPage from '@forwardflow/pages/Onboarding/OnboardingPage'
import { OnboardingHandoffPage } from '@forwardflow/pages/OnboardingHandoff'

import VerifyEmail from '../pages/Onboarding/VerifyEmail'
import PhoneNumberLayout from '../layouts/PhoneNumberLayout'
import Calendar from '../pages/Calendar'
import Conversations from '../pages/Conversations'
import NotFound from '../pages/NotFound'
import Terms from '../pages/Terms'
import Privacy from '../pages/Privacy'
import DemoSignup from '../pages/DemoSignUp'
import Logout from '@forwardflow/components/Logout'
// import CombinedRouteProtection from './CombinedProtectedRoutes/CombinedProtectedRoutes'
import * as Sentry from '@sentry/react'
import MarketingAnalytics from '@forwardflow/pages/MarketingAnalytics'
import DemoConversationLayout from '@forwardflow/layouts/DemoConversationLayout'
import SelectUserOrganization from '@forwardflow/components/SelectUserOrganization'

import RoleBasedRoute from './RoleBasedRoute/RoleBasedRoute'
import ConversationLayout from '@forwardflow/layouts/ConversationLayout'
import { PhoneNumberManagementPage } from '@forwardflow/pages/phone-number-management/PhoneNumberManagementPage'

// const isDevEnvironment = () => {
//    const hostname = window.location.hostname
//    return (
//       hostname.includes('dev-') ||
//       hostname.includes('development-') ||
//       hostname === 'localhost' ||
//       hostname.includes('127.0.0.1')
//    )
// }

const Routing = () => {
   // const isDevelopment = isDevEnvironment()
   const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

   return (
      <SentryRoutes>
               <Route element={<AppLayout />}>
                  <Route path="/" element={<Signin />} />
                  <Route path="/logout" element={<Logout />} />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/signup/assistant/:assistantHandle" element={<Signup />} />
                  <Route path="/demo-signup" element={<DemoSignup />} />
                  <Route path="/signin" element={<Signin />} />
                  {/* Public on purpose: it does its own token check. Inside
                      ProtectedRoutesLayout the org-navigation effect would
                      route the user away before the handoff could run. */}
                  <Route
                     path="/connect/assistant"
                     element={<ConnectAssistant />}
                  />
                  {/*
                    Plan 261 — a task handed over from a conversation.

                    OUTSIDE `ProtectedRoutesLayout`, beside `/connect/assistant`
                    and for the same reason: that layout runs an
                    organization-navigation effect on mount which sends a
                    customer with incomplete onboarding to `/onboarding`. On
                    this route that defeats the focused payment, CRM or
                    calendar journey the person was sent here for — and it can
                    race a single-use redemption, burning the link on a page
                    they never see. The page does its own, narrower check.
                  */}
                  <Route
                     path="/onboarding/assistant"
                     element={<OnboardingHandoffPage />}
                  />

                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route
                     path="/forgot-password"
                     element={<ForgotPassword />}
                  />
                  <Route
                     path="/set-new-password"
                     element={<SetNewPassword />}
                  />
                  <Route element={<ProtectedRoutesLayout />}>
                     <Route element={<ProtectRoutes />}>
                        <Route
                           path="/initializing"
                           element={<SelectUserOrganization />}
                        />
                        <Route
                           path="/onboarding"
                           element={<OnboardingPage />}
                        />

                        {/* Non-agent routes */}
                        <Route
                           path="/demo-conversations-old/:id"
                           element={<ConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations-old"
                           element={<ConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations/:id"
                           element={<DemoConversationLayout />}
                        />
                        <Route
                           path="/demo-conversations"
                           element={<DemoConversationLayout />}
                        />
                        {/* 
                        <Route
                           element={
                              <CombinedRouteProtection
                                 requireOnboarding={!isDevelopment}
                                 showFirstSignInModal={true}
                              />
                           }
                        > */}
                        <Route
                           path="/dashboard"
                           element={<Dashboard />}
                        />

                        {/* Non-agent routes */}
                        <Route
                           element={
                              <RoleBasedRoute excludedRoles={['Agent']} />
                           }
                        >
                           <Route
                              path="/campaign/*"
                              element={<CampaignRoutes />}
                           />
                        </Route>
                        <Route
                           path="/marketing"
                           element={<MarketingAnalytics />}
                        />
                        <Route
                           path="/conversations/"
                           element={<Conversations />}
                        />
                        <Route
                           path="/conversations/:id"
                           element={<Conversations />}
                        />
                        <Route
                           path="/phone-numbers/*"
                           element={<PhoneNumberLayout />}
                        />
                        <Route
                           path="/settings/*"
                           element={<SettingsLayout />}
                        />
                        <Route path="/calendar/*" element={<Calendar />} />
                        <Route
                           path="/phone-number-management"
                           element={<PhoneNumberManagementPage />}
                        />
                     </Route>
                  </Route>
               </Route>
               <Route path="*" element={<NotFound />} />
               {/* </Route> */}
      </SentryRoutes>
   )
}

export default Routing
